import React, { useMemo } from "react";
import Direction from "views/logic/aggregationbuilder/Direction";
import SortConfig from "views/logic/aggregationbuilder/SortConfig";
import { SortIcon } from "components/common";
const _tooltip = (fieldName, newDirection) => newDirection ? `Sort ${fieldName} ${newDirection.direction}` : `Remove ${fieldName} sort`;
const _changeSort = (nextDirection, sortConfigMap, fieldName, onSortChange, setLoadingState, type, activeSort) => {
  let newSortConfigSet;
  if (activeSort) {
    newSortConfigSet = sortConfigMap.set(fieldName, new SortConfig(type, fieldName, nextDirection));
  } else {
    newSortConfigSet = sortConfigMap.delete(fieldName);
  }
  setLoadingState(true);
  onSortChange(newSortConfigSet.toList().toArray()).then(() => {
    setLoadingState(false);
  });
};
const _isFieldSortActive = (sortConfigMap, fieldName) => sortConfigMap.get(fieldName);
const DirectionStrategyAsc = {
  tooltip: (fieldName) => _tooltip(fieldName, Direction.Descending),
  handleSortChange: (changeSort) => changeSort(Direction.Descending, true)
};
const DirectionStrategyDesc = {
  tooltip: (fieldName) => _tooltip(fieldName, null),
  handleSortChange: (changeSort) => changeSort(Direction.Descending, false)
};
const DirectionStrategyNoSort = {
  tooltip: (fieldName) => _tooltip(fieldName, Direction.Ascending),
  handleSortChange: (changeSort) => changeSort(Direction.Ascending, true)
};
const _directionStrategy = (activeDirection) => {
  switch (activeDirection) {
    case Direction.Ascending.direction:
      return DirectionStrategyAsc;
    case Direction.Descending.direction:
      return DirectionStrategyDesc;
    default:
      return DirectionStrategyNoSort;
  }
};
const FieldSortIcon = ({ fieldName, type, sortConfigMap, onSortChange, setLoadingState }) => {
  var _a, _b;
  const changeSort = (nextDirection, activeSort) => _changeSort(nextDirection, sortConfigMap, fieldName, onSortChange, setLoadingState, type, activeSort);
  const activeDirection = (_b = (_a = _isFieldSortActive(sortConfigMap, fieldName)) == null ? void 0 : _a.direction) == null ? void 0 : _b.direction;
  const { tooltip, handleSortChange } = _directionStrategy(activeDirection);
  const order = useMemo(() => {
    if (sortConfigMap.size < 2) return void 0;
    const index = sortConfigMap.keySeq().findIndex((k) => k === fieldName) + 1;
    return index || void 0;
  }, [fieldName, sortConfigMap]);
  const title = tooltip(fieldName);
  return /* @__PURE__ */ React.createElement(
    SortIcon,
    {
      onChange: () => handleSortChange(changeSort),
      activeDirection,
      title,
      order
    }
  );
};
export default FieldSortIcon;
